module.exports = __webpack_public_path__ + "img/prof1.efa04542.jpg";